import React from 'react'
import { formatTimeOfDay } from '../../utils/api'
import { replyAuthorLabel } from './replyAuthor.js'

/**
 * Shown when the server refused a reply because the ticket moved on since
 * the operator loaded it (a colleague answered, or the customer wrote
 * again). Names who moved it and reassures them the draft is untouched.
 */
function StaleReplyNotice({ notice, currentUserId, ticketUsers, onDismiss }) {
  if (!notice) return null
  return (
    <div role="alert" className="stale-reply-notice">
      <span>{describe(notice.latest_reply, { currentUserId, ticketUsers })} The thread has been reloaded and your draft is untouched.</span>
      <button type="button" className="btn btn-sm btn-ghost" onClick={onDismiss} aria-label="Dismiss">×</button>
    </div>
  )
}

function describe(latestReply, { currentUserId, ticketUsers }) {
  if (!latestReply) return 'This ticket changed since you opened it.'
  const at = formatTimeOfDay(latestReply.sent_at)
  if (latestReply.direction === 'in') return `The customer sent a new message at ${at}.`
  const who = replyAuthorLabel(latestReply, { currentUserId, ticketUsers, customerName: null })
  return `${who} replied at ${at}.`
}

export default StaleReplyNotice
